<template>
  <div v-show="true" class="pl-4 w-full h-full flex flex-col bg-white dark:bg-dark-screen-background p-2 overflow-y-scroll rounded-md">
    <div class="w-full flex justify-between items-center mb-2 pr-2">
      <div class="flex items-center truncate overflow-ellipsis">
        <span class="mr-1 text-[20px] not-italic font-medium font-sans truncate overflow-ellipsis">{{ label }}</span>
      </div>
      <div class="flex items-center">
        <div v-if="checklists.length" class="mr-1">
          <MultiSelectInput
            v-model:current-items="selected_filters"
            :value="selected_filters"
            name="filters"
            :items="all_filters"
            :allow-null="true"
            :label="$t('Showing checklist')"
            classes="w-full"
            input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
            :selection-text="null"
            :placeholder="$t('Showing checklist')"
            :show-label="false" />
        </div>
        <button
          :class="[{ 'has-tooltip': editing_disabled }]"
          :disabled="editing_disabled"
          type="button"
          class="primary-btn w-fit"
          @click="
            () => {
              is_public = true
              create_new_checklist_modal_is_open = true
            }
          ">
          <span class="text-[14px] not-italic font-normal font-sans leading-5">{{ $t("Create new checklist") }}</span>
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </button>
      </div>
    </div>
    <div v-if="checklists.length && !record_not_found" class="relative flex flex-wrap w-full">
      <!--h-[calc(100%-46px)]-->
      <div
        v-for="([name], index) in selected_filters.length == 0
          ? checklists
          : checklists.filter((c) => selected_filters.find((f) => f == c[0]))"
        :key="name"
        class="mb-2 relative flex bg-light-box-background dark:bg-dark-box-background transition-ease-in-out duration-side-menu-transition-duration"
        :class="[
          width >= 60 && metrics_group.length >= 3
            ? 'w-1/3'
            : width >= 60 && metrics_group.length == 2
              ? 'w-1/2'
              : width >= 60 && metrics_group.length < 2
                ? 'w-full'
                : width < 60 && width > 52 && metrics_group.length >= 2
                  ? 'w-1/2'
                  : width < 60 && width > 52 && metrics_group.length < 2
                    ? 'w-full'
                    : width <= 52
                      ? 'w-full'
                      : ''
        ]">
        <div
          v-if="!checklists.find((c) => c[0] == name)[2].collapsed && width <= 52"
          class="w-[calc(100%-8px)] shrink-0 relative max-w-full border p-2 rounded-md shadow-md h-[52px]">
          <div class="flex justify-between items-center">
            <div
              class="cursor-pointer font-bold dark:text-dark-body-text flex flex-nowrap truncate overflow-ellipsis w-full"
              @click="collapseChecklist(name)">
              {{ name }}
            </div>
            <div class="flex items-center">
              <div
                v-if="groups_checked_counts[name].completed >= groups_checked_counts[name].max"
                class="whitespace-nowrap py-1 px-2 rounded-full bg-status-success-green text-white dark:text-dark-body-text">
                {{ $t("Completed") }}
              </div>
              <div
                v-else
                class="whitespace-nowrap py-1 px-2 rounded-full text-light-body-text dark:text-dark-body-text"
                :class="[
                  (groups_checked_counts[name].completed * 100) / groups_checked_counts[name].max >= 75
                    ? 'bg-status-success-green'
                    : (groups_checked_counts[name].completed * 100) / groups_checked_counts[name].max >= 50
                      ? 'bg-status-warning-yellow'
                      : 'bg-status-error-red',
                  is_checklist_remove_fields_on ? 'right-24' : 'right-[50px]',
                  editing_disabled ? 'right-[0px]' : ''
                ]">
                {{ groups_checked_counts[name].completed }}/{{ groups_checked_counts[name].max }} {{ $t("completed") }}
              </div>
            </div>
            <div v-if="width <= 52" class="cursor-pointer flex items-center" @click="collapseChecklist(name)">
              <Maximize2 class="w-5 h-5 ml-1" />
            </div>
          </div>
        </div>
        <div
          v-else-if="checklists.find((c) => c[0] == name)[2].collapsed || width > 52"
          class="w-[calc(100%-8px)] shrink-0 relative max-w-full h-full border p-2 rounded-md shadow-md">
          <div class="flex justify-between">
            <div
              class="cursor-pointer font-bold dark:text-dark-body-text flex flex-nowrap truncate overflow-ellipsis w-full"
              @click="collapseChecklist(name)">
              {{ name }}
            </div>
            <div class="flex items-center ml-auto">
              <Menu v-if="!editing_disabled" as="div" class="flex items-center flex-shrink-0">
                <MenuButton
                  class="inline-flex items-center justify-center text-gray-400 transition ease-in-out bg-white rounded dark:bg-dark-box-background duration-side-menu-transition-duration"
                  @click.stop="">
                  <span class="sr-only">{{ $t("Open options") }}</span>
                  <EllipsisVertical :color="$store.state.ui.darkMode ? '#fff' : ''" class="w-5 h-5 border-none" />
                </MenuButton>
                <transition
                  enter-active-class="transition duration-100 ease-out"
                  enter-from-class="transform scale-95 opacity-0"
                  enter-to-class="transform scale-100 opacity-100"
                  leave-active-class="transition duration-75 ease-in"
                  leave-from-class="transform scale-100 opacity-100"
                  leave-to-class="transform scale-95 opacity-0">
                  <MenuItems
                    class="absolute top-0 right-0 z-30 flex flex-col items-start content-center justify-center p-2 mx-3 mt-1 origin-top-right bg-white rounded-md shadow-lg outline-none dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <MenuItem
                      v-slot="{ active }"
                      @click.prevent="
                        () => {
                          checklist_group_selected = name
                          checklist_name = name
                          is_public = forecast_checklist.find((c) => c.metric_group == name).is_public
                          edit_checklist_modal_is_open = true
                        }
                      ">
                      <div
                        :class="[
                          active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                          'group flex items-center px-3 py-2 text-sm cursor-pointer'
                        ]">
                        <Pencil class="w-5 h-5 mr-2" aria-hidden="true" />
                        <span>{{ $t("Edit checklist details") }}</span>
                      </div>
                    </MenuItem>
                    <MenuItem v-slot="{ active }" @click.prevent="">
                      <div
                        :class="[
                          active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                          'group flex items-center px-3 py-2 text-sm cursor-pointer'
                        ]"
                        @click.prevent="
                          () => {
                            checklist_group_selected = name
                            selected_metrics = groups[index]
                            edit_fields_modal_is_open = true
                          }
                        ">
                        <Plus class="mr-2 h-5 w-5" aria-hidden="true" />
                        <span>{{ $t("Edit fields") }}</span>
                      </div>
                    </MenuItem>
                    <MenuItem
                      v-slot="{ active }"
                      @click.prevent="
                        () => {
                          checklist_group_selected = name
                          show_delete_confirmation_modal = true
                        }
                      ">
                      <div
                        :class="[
                          active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                          'group flex items-center px-3 py-2 text-sm cursor-pointer'
                        ]">
                        <Trash2 class="w-5 h-5 mr-2" aria-hidden="true" />
                        <span>{{ $t("Delete checklist") }}</span>
                      </div>
                    </MenuItem>
                  </MenuItems>
                </transition>
              </Menu>
              <div v-if="width <= 52" class="cursor-pointer flex items-center" @click="collapseChecklist(name)">
                <Minimize2 class="w-5 h-5 ml-1" />
              </div>
            </div>
          </div>
          <div class="flex justify-between mt-1">
            <div
              v-if="groups_checked_counts[name].completed >= groups_checked_counts[name].max"
              class="py-1 px-2 rounded-full bg-status-success-green text-white dark:text-dark-body-text">
              {{ $t("Completed") }}
            </div>
            <div
              v-else
              class="py-1 px-2 rounded-full text-light-body-text dark:text-dark-body-text"
              :class="[
                (groups_checked_counts[name].completed * 100) / groups_checked_counts[name].max >= 75
                  ? 'bg-status-success-green'
                  : (groups_checked_counts[name].completed * 100) / groups_checked_counts[name].max >= 50
                    ? 'bg-status-warning-yellow'
                    : 'bg-status-error-red',
                is_checklist_remove_fields_on ? 'right-24' : 'right-[50px]',
                editing_disabled ? 'right-[0px]' : ''
              ]">
              {{ groups_checked_counts[name].completed }}/{{ groups_checked_counts[name].max }} {{ $t("completed") }}
            </div>
            <button
              v-if="!is_edit_fields_on || (is_edit_fields_on && checklist_group_selected != name)"
              class="btn font-normal right-2 absolute cancel-btn border-dark-brand-blue"
              @click.prevent="
                () => {
                  checklist_group_selected = name
                  is_edit_fields_on = true
                }
              ">
              <Pencil color="#2da7d7" class="w-5 h-5 relative right-2 text-dark-brand-blue" />{{ $t("Edit") }}
            </button>
            <button
              v-else-if="is_edit_fields_on && checklist_group_selected == name"
              class="btn font-normal right-2 absolute cancel-btn border-dark-brand-blue"
              @click.prevent="
                () => {
                  is_edit_fields_on = false
                }
              ">
              <Check class="w-5 h-5 text-dark-brand-blue font-bold" aria-hidden="true" />{{ $t("Done") }}
            </button>
          </div>
          <div class="flex flex-col mt-4 relative w-full h-[calc(100%-70px)] overflow-auto">
            <div v-for="element in groups[index]" :key="element.id" class="w-full">
              <div
                v-if="!is_edit_fields_on || checklist_group_selected != element.metric_group"
                class="flex flex-row flex-nowrap shrink-0 justify-between py-2 px-2 w-full">
                <div class="flex items-center w-[calc(100%-30px)]">
                  <div v-if="!element.value" class="flex items-center justify-center rounded-full bg-gray-300 w-7 h-7 flex-shrink-0">
                    <span class="rounded-full bg-white w-3 h-3" />
                  </div>
                  <div v-else class="flex items-center justify-center rounded-full bg-[#20D29F] w-7 h-7 flex-shrink-0">
                    <Check class="w-5 h-5 text-white font-bold" aria-hidden="true" />
                  </div>
                  <div class="flex flex-col w-full ml-1 has-tooltip">
                    <span class="w-full relative font-medium cursor-pointer truncate whitespace-nowrap">{{ element.name }}</span>
                    <span
                      v-if="element.name.length > 50"
                      class="flex flex-wrap w-[calc(100%-50px)] px-2 py-1 text-sm font-medium rounded-md tooltip bg-light-screen-background">
                      {{ element.name }}</span>
                    <div v-if="element.input_type == 'StarRating' && element.value" class="flex justify-start w-full">
                      <span v-for="f in element.value" :key="f" :class="{ 'mr-1': f < 5 }">
                        <svg
                          class="block w-5 h-5"
                          :class="[
                            element.value >= f
                              ? element.value >= 4
                                ? 'text-status-success-green'
                                : element.value >= 3
                                  ? 'text-status-warning-yellow'
                                  : 'text-status-error-red'
                              : 'text-gray-300'
                          ]"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20">
                          <path
                            d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                        </svg>
                      </span>
                    </div>
                    <div
                      v-else-if="element.input_type == 'BarRating'"
                      class="text-[14px] not-italic font-normal font-sans leading-normal text-common-grey">
                      <span> {{ element.value }}/10 </span>
                    </div>
                    <div v-else-if="element.input_type == 'Checkbox'" class="flex justify-start w-full">
                      <input class="rounded text-blue-light" :disabled="true" type="checkbox" :checked="element.value">
                    </div>
                    <span v-else-if="element.value"
                          class="text-[14px] not-italic font-normal font-sans leading-normal text-common-grey">{{ element.value }}
                    </span>
                    <Minus v-else class="w-3" color="#000" />
                  </div>
                </div>
              </div>
              <div
                v-else-if="is_edit_fields_on && checklist_group_selected == element.metric_group"
                class="flex flex-col justify-start w-full mb-2">
                <p class="text-gray-500 dark:text-[#909EA6] font-normal">
                  {{ element.name }}
                </p>
                <MetricFieldInput
                  :metric-value="element.value"
                  :disabled="editing_disabled"
                  :show-label="false"
                  :metric="element"
                  :record="component_record"
                  :is-box-background="false"
                  class="w-full"
                  @update:metric-value="($event) => handleUpdateValue($event, element, name)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!record_not_found" class="text-common-grey p-3">
      {{ $t("No checklists available, Press on 'Create new checklist' button to add a new one") }}.
    </div>
  </div>

  <!-- Create new checklist -->
  <Modal
    v-model:is-open="create_new_checklist_modal_is_open"
    max-width="max-w-[750px]"
    :use-toast="true"
    :default-success-msg="$t('You have successfully created checklist')">
    <template #form="{ done: showIsDone }">
      <div class="w-full h-full flex-col mx-2">
        <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute rounded-t-lg left-0 top-0 pointer-events-none" />
        <div class="flex items-center w-full">
          <Group class="w-12 h-12 -ml-1" color="#000" />
          <span class="mt-1 ml-2 text-3xl font-bold text-black">{{ $t("Create New Checklist") }}</span>
          <div
            class="flex items-center justify-center w-8 h-8 ml-auto mr-3 bg-white border rounded-full cursor-pointer has-tooltip dark:border-dark-divider-border dark:bg-dark-screen-background"
            @click="
              () => {
                create_new_checklist_modal_is_open = false
                selected_metrics = []
              }
            ">
            <X color="#FF0000" class="w-6 h-6 transition ease-in-out duration-side-menu-transition-duration" /><span
              class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
              {{ $t("Close") }}</span>
          </div>
        </div>
        <div class="text-common-grey">
          {{ $t("Create a list of metrics required, things to be done, or points to be considered, used as a reminder.") }}
        </div>

        <div class="mt-4 pt-2">
          <div class="flex items-center justify-center my-2">
            <TextInput
              v-model="checklist_name"
              class="w-full"
              :is-box-background="true"
              :show-label="false"
              :auto-focus="false"
              input-classes="appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light bg-white focus:border-blue-light sm:text-sm"
              name="name"
              type="text"
              :placeholder="$t('Checklist Name')"
              label=""
              @input="checklist_name = $event.target.value" />
            <div class="flex flex-row items-center gap-2 ml-2">
              <label class="block text-base font-medium text-gray-700 dark:text-dark-body-text">{{ $t("Private") }} </label>
              <Switch
                v-model="is_public"
                :class="[
                  !is_public ? 'bg-blue' : 'bg-gray-200 dark:bg-dark-screen-background',
                  'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
                ]">
                <span
                  aria-hidden="true"
                  :class="[
                    !is_public && $store.state.portfolio.ui_options?.language == 'ar'
                      ? '-translate-x-5'
                      : !is_public
                        ? 'translate-x-5'
                        : 'translate-x-0',
                    'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                  ]" />
              </Switch>
            </div>
          </div>
        </div>
        <div>
          <DualList
            v-model:current-items="selected_metrics"
            name="selected_metrics"
            :object-type="component_record.type"
            :show-filters="true"
            :all-items="$store.state.metrics.filter((m) => m.object_type == component_record.type)"
            :selected-items="selected_metrics"
            :return-objects="false"
            :allow-null="false"
            :label="$t('Existing Metrics')"
            label-attr="name"
            value-attr="id" />
        </div>
        <div class="flex flex-row-reverse items-center w-full gap-2 mt-12">
          <button
            class="primary-btn w-fit"
            :disabled="selected_metrics.length == 0 || !checklist_name"
            @click="createNewChecklist(showIsDone)">
            <span>{{ $t("Create") }}</span>
            <Check class="w-6 h-6 ml-2" aria-hidden="true" />
          </button>
          <button
            type="button"
            class="w-fit cancel-btn py-2.5 -ml-1"
            @click="
              () => {
                create_new_checklist_modal_is_open = false
                selected_metrics = []
              }
            ">
            <span>{{ $t("Cancel") }}</span>
          </button>
        </div>
      </div>
    </template>
  </Modal>

  <!-- Edit details checklist -->
  <Modal
    v-model:is-open="edit_checklist_modal_is_open"
    max-width="max-w-[750px]"
    :use-toast="true"
    :default-success-msg="$t('You have successfully updated checklist')">
    <template #form="{ done: showIsDone }">
      <div class="w-full h-full flex-col mx-2">
        <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute rounded-t-lg left-0 top-0 pointer-events-none" />
        <div class="flex items-center w-full">
          <Group class="w-12 h-12 -ml-1" color="#000" />
          <span class="mt-1 ml-2 text-3xl font-bold text-black">{{ $t("Edit Checklist") }}</span>
          <div
            class="w-8 h-8 ml-auto mr-3 bg-white border rounded-full cursor-pointer has-tooltip dark:border-dark-divider-border dark:bg-dark-screen-background"
            @click="edit_checklist_modal_is_open = false">
            <X color="#FF0000" class="w-4 h-4 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
              class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
              {{ $t("Close") }}</span>
          </div>
        </div>

        <div class="mt-4 pt-2">
          <div class="flex items-center justify-center my-2">
            <TextInput
              v-model="checklist_name"
              :value="checklist_name"
              class="w-full"
              :is-box-background="true"
              :show-label="false"
              :auto-focus="false"
              input-classes="appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light bg-white focus:border-blue-light sm:text-sm"
              name="name"
              type="text"
              :placeholder="$t('Checklist Name')"
              label=""
              @input="checklist_name = $event.target.value" />
            <div class="flex flex-row items-center gap-2 ml-2">
              <label class="block text-base font-medium text-gray-700 dark:text-dark-body-text">{{ $t("Private") }} </label>
              <Switch
                v-model="is_public"
                :class="[
                  !is_public ? 'bg-blue' : 'bg-gray-200 dark:bg-dark-screen-background',
                  'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
                ]">
                <span
                  aria-hidden="true"
                  :class="[
                    !is_public && $store.state.portfolio.ui_options?.language == 'ar'
                      ? '-translate-x-5'
                      : !is_public
                        ? 'translate-x-5'
                        : 'translate-x-0',
                    'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                  ]" />
              </Switch>
            </div>
          </div>
        </div>
        <div class="flex flex-row-reverse items-center w-full gap-2 mt-12">
          <button class="primary-btn w-fit" @click="updateChecklist(showIsDone)">
            <span>{{ $t("Update") }}</span>
            <Check class="w-6 h-6 ml-2" aria-hidden="true" />
          </button>
          <button type="button" class="w-fit cancel-btn py-2.5 -ml-1" @click="edit_checklist_modal_is_open = false">
            <span>{{ $t("Cancel") }}</span>
          </button>
        </div>
      </div>
    </template>
  </Modal>

  <!-- Edit fields -->
  <Modal
    v-model:is-open="edit_fields_modal_is_open"
    max-width="max-w-[750px]"
    :use-toast="true"
    :default-success-msg="$t('You have successfully updated checklist')">
    <template #form="{ done: showIsDone }">
      <div class="w-full h-full flex-col mx-2">
        <DualList
          v-model:current-items="selected_metrics"
          name="included_metrics"
          :object-type="component_record.type"
          :show-filters="true"
          :all-items="$store.state.metrics"
          :selected-items="selected_metrics"
          :return-objects="false"
          label-attr="name"
          value-attr="id" />
        <div class="flex flex-row-reverse items-center w-full gap-2 mt-12">
          <button class="primary-btn w-fit" @click="reorderChecklist(showIsDone)">
            <span>{{ $t("Update") }}</span>
            <Check class="w-6 h-6 ml-2" aria-hidden="true" />
          </button>
          <button
            type="button"
            class="w-fit cancel-btn py-2.5 -ml-1"
            @click="
              () => {
                selected_metrics = []
                edit_fields_modal_is_open = false
              }
            ">
            <span>{{ $t("Cancel") }}</span>
          </button>
        </div>
      </div>
    </template>
  </Modal>

  <!-- delete checklist  -->
  <Modal v-model:is-open="show_delete_confirmation_modal" :use-toast="true" :default-success-msg="$t('Checklist Deleted')">
    <template #form="{ done: showIsDone }">
      <button
        class="inset-y-0 right-0 flex items-center justify-center float-right w-6 h-6 ml-5 rounded-full group hover:bg-gray-300"
        type="button"
        @click="show_delete_confirmation_modal = false">
        <X class="w-5 h-5 text-red-500 group-hover:cursor-pointer" aria-hidden="true" />
      </button>
      <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-dark-body-text">
        {{ $t("Delete Checklist") }}
      </h3>
      <div class="max-w-xl mt-2 text-gray-500 text-md">
        <p>{{ $t("Do you want to delete this checklist ?") }}</p>
      </div>
      <div class="mt-5 text-center">
        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 font-medium text-red-700 bg-red-100 border border-transparent rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
          @click="deleteChecklist(showIsDone)">
          {{ $t("Delete Checklist") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useLayoutItemSharedLogic } from "@/components/shared/pages/useLayoutItemSharedLogic.js"
import { Group, Maximize2, Minimize2, X, Check, Plus, Trash2, EllipsisVertical, Pencil, Minus } from "lucide-vue-next"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import dataService from "@/services/data.service"
import MetricFieldInput from "@/components/shared/MetricFieldInput.vue"
import Modal from "@/components/shared/Modal.vue"
import { Switch } from "@headlessui/vue"
import TextInput from "@/components/shared/TextInput.vue"
import MultiSelectInput from "@/components/shared/MultiSelectInput.vue"
import DualList from "@/components/shared/DualList.vue"

export default {
  name: "ForecastChecklistTab",
  components: {
    Maximize2,
    Minimize2,
    MultiSelectInput,
    DualList,
    Modal,
    Switch,
    Group,
    TextInput,
    MetricFieldInput,
    Check,
    Trash2,
    Pencil,
    X,
    EllipsisVertical,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Minus,
    Plus
  },
  inject: ["canUserEditLayout"],
  props: {
    width: {
      type: Number,
      required: false
    },
    componentReference: {
      type: String,
      required: false
    },
    linkedRecord: null,
    connectTo: null,
    label: null
  },
  data() {
    return {
      loading: false,
      record_error: false,
      component_record: null,
      checklists: [],
      selected_filters: [],
      all_filters: [],
      initial_values: {},
      checklist_name: "",
      is_public: true,
      selected_metrics: [],
      is_edit_fields_on: false,
      create_new_checklist_modal_is_open: false,
      edit_checklist_modal_is_open: false,
      edit_fields_modal_is_open: false,
      is_checklist_remove_fields_on: false,
      show_delete_confirmation_modal: false,
      metrics_group: [],
      checklist_group_selected: null,
      forecast_checklist: [],
      groups_checked_counts: {},
      groups: [],
      updated_checklist_name: "",
      record_not_found: false
    }
  },
  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    }
  },

  watch: {
    selected_filters: {
      deep: true,
      handler() {
        let collapsed_lists = this.$store.state.ui_options?.collapsed_checklists
          ? this.$store.state.ui_options.collapsed_checklists[this.componentReference]?.checklists
          : []
        this.$store.dispatch("ui/setUIValue", {
          collapsed_checklists: {
            ...this.$store.state.ui_options?.collapsed_checklists,
            [this.componentReference]: { checklists: collapsed_lists, filters: this.selected_filters.map((f) => f) }
          }
        })
        if (this.selected_filters.length > 0) {
          this.groups = []
          Object.entries(this.$utils.groupBy(this.forecast_checklist, "metric_group")).map((group) => {
            this.groups.push(group[1])
          })
          this.groups = this.$utils.clone(this.groups.filter((group) => this.selected_filters.includes(group[0].metric_group)))
          this.metrics_group = this.$utils.clone(this.selected_filters)
        } else {
          this.groups = []
          Object.entries(this.$utils.groupBy(this.forecast_checklist, "metric_group")).map((group) => {
            this.groups.push(group[1])
          })
          this.metrics_group = Object.entries(this.$utils.groupBy(this.forecast_checklist, "metric_group")).map((x) => {
            return x[0]
          })
        }
      }
    },
    groups_checked_counts: {
      deep: true,
      handler() {
        if (
          this.groups_checked_counts[this.updated_checklist_name] &&
          this.groups_checked_counts[this.updated_checklist_name].completed >= this.groups_checked_counts[this.updated_checklist_name].max
        ) {
          if (
            this.$store.state.ui_options?.collapsed_checklists &&
            this.$store.state.ui_options.collapsed_checklists[this.componentReference]
          ) {
            let i = this.checklists.findIndex((c) => c[0] == this.updated_checklist_name)
            if (i != -1) {
              this.checklists[i][2].collapsed = false
            }

            let collapsed_lists = this.$store.state.ui_options.collapsed_checklists[this.componentReference]?.checklists
              ? this.$store.state.ui_options.collapsed_checklists[this.componentReference].checklists
              : []
            this.selected_filters = this.$store.state.ui_options.collapsed_checklists[this.componentReference]?.filters
              ? this.$store.state.ui_options.collapsed_checklists[this.componentReference].filters
              : []
            let index = collapsed_lists.findIndex((c) => c == this.updated_checklist_name)
            if (index != -1) {
              collapsed_lists.splice(index, 1)
              this.$store.dispatch("ui/setUIValue", {
                collapsed_checklists: {
                  ...this.$store.state.ui_options?.collapsed_checklists,
                  [this.componentReference]: { checklists: collapsed_lists, filters: this.selected_filters }
                }
              })
            }
          }
        }
      }
    },
    is_edit_fields_on() {
      if (!this.is_edit_fields_on) {
        this.initChecklist()
      }
    }
  },
  created() {
    const { loading, record_error, component_record } = useLayoutItemSharedLogic(
      this.$props,
      this.postGetComponentRecord,
      this.registerListeners,
      this.unregisterListeners
    )
    this.loading = loading
    this.record_error = record_error
    this.component_record = component_record
  },
  methods: {
    postGetComponentRecord() {
      this.initChecklist()
    },
    registerListeners() {},
    unregisterListeners() {},
    collapseChecklist(name) {
      this.checklists.find((c) => c[0] == name)[2].collapsed = !this.checklists.find((c) => c[0] == name)[2].collapsed
      let collapsed_lists = this.checklists.filter((c) => c[2].collapsed == true).map((c) => c[0])

      this.$store.dispatch("ui/setUIValue", {
        collapsed_checklists: {
          ...this.$store.state.ui_options?.collapsed_checklists,
          [this.componentReference]: { checklists: collapsed_lists, filters: this.selected_filters }
        }
      })
    },
    handleUpdateValue(value, metric, name) {
      this.updated_checklist_name = name
      metric.value = value
      if (this.connectTo == "another_record") {
        setTimeout(() => {
          //this.getTiedCompany()
        }, 500)
      }
    },
    createNewChecklist(showIsDone) {
      dataService
        .createForeCastChecklist({
          type: this.component_record.type,
          object_type: this.component_record.object_type,
          is_public: this.is_public,
          name: this.checklist_name,
          included_metrics: this.selected_metrics
        })
        .then(() => {
          this.checklist_name = ""
          this.selected_metrics = []
          this.create_new_checklist_modal_is_open = false
          this.initChecklist()
          showIsDone()
        })
    },
    updateChecklist(showIsDone) {
      dataService.getForeCastChecklist({ page_size: 100, type: this.component_record.type }).then((result) => {
        let group = result.data.results.find((x) => x.name == this.checklist_group_selected)
        dataService.updateForeCastChecklist(group.id, { name: this.checklist_name, is_public: this.is_public }).then(() => {
          this.checklist_name = ""
          this.edit_checklist_modal_is_open = false
          this.initChecklist()
          showIsDone()
        })
      })
    },
    reorderChecklist() {
      dataService.getForeCastChecklist({ page_size: 100, type: this.component_record.type }).then((result) => {
        let group = result.data.results.find((x) => x.name == this.checklist_group_selected)
        dataService.updateForeCastChecklist(group.id, { included_metrics: this.selected_metrics }).then(() => {
          this.initChecklist()
          this.selected_metrics = []
          this.edit_fields_modal_is_open = false
        })
      })
    },
    initChecklist() {
      dataService
        .getForeCastChecklist({ page_size: 100, type: this.component_record.type, company: this.component_record.id })
        .then((result) => {
          this.forecast_checklist = []
          result.data.results.map((group) => {
            let groupCheckCount = 0
            let groupCheckedCount = 0
            group.included_metrics.map((id) => {
              groupCheckCount += 1

              let metric = this.$utils.getMetricById(id)
              metric.value = this.component_record.values[metric.reference_name]
              if (metric.value) {
                groupCheckedCount += 1
              }

              let input_type, options
              if (metric.aggregation_method) {
                input_type = "number"
                options = null
              } else {
                input_type = metric.input_type
                options = metric?.input_options
              }
              this.initial_values[metric.reference_name] = this.component_record.values[metric.reference_name]
              if (input_type == "checkbox") {
                this.forecast_checklist.push({
                  id: metric.id,
                  name: metric.name,
                  input_type: input_type,
                  input_options: options,
                  default: null,
                  value: metric.value == "Yes" ? true : false,
                  metric_class: metric.metric_class,
                  metric_group: group.name,
                  is_public: group.is_public,
                  reference_name: metric.reference_name
                })
              } else {
                this.forecast_checklist.push({
                  id: metric.id,
                  name: metric.name,
                  input_type: input_type,
                  input_options: options,
                  default: null,
                  value: metric.value,
                  metric_class: metric.metric_class,
                  metric_group: group.name,
                  is_public: group.is_public,
                  reference_name: metric.reference_name
                })
              }
            })
            this.groups_checked_counts = {
              ...this.groups_checked_counts,
              [group.name]: {
                max: groupCheckCount,
                completed: groupCheckedCount
              }
            }
          })
          this.groups = []
          Object.entries(this.$utils.groupBy(this.forecast_checklist, "metric_group")).map((group) => {
            this.groups.push(group[1])
          })
          this.metrics_group = Object.entries(this.$utils.groupBy(this.forecast_checklist, "metric_group")).map((x) => {
            return x[0]
          })
          this.all_filters = this.$utils.clone(this.metrics_group)
          if (!this.checklist_group_selected) {
            this.checklist_group_selected = this.metrics_group[0]
          }
          this.checklists = Object.entries(this.$utils.groupBy(this.forecast_checklist, "metric_group"))

          if (
            this.$store.state.ui_options?.collapsed_checklists &&
            this.$store.state.ui_options.collapsed_checklists[this.componentReference]
          ) {
            let collapsed_lists = this.$store.state.ui_options.collapsed_checklists[this.componentReference]?.checklists
              ? this.$store.state.ui_options.collapsed_checklists[this.componentReference].checklists
              : []
            this.selected_filters = this.$store.state.ui_options.collapsed_checklists[this.componentReference]?.filters
              ? this.$store.state.ui_options.collapsed_checklists[this.componentReference].filters
              : []

            this.checklists.map((list) => {
              if (collapsed_lists.includes(list[0])) {
                list.push({ collapsed: true })
              } else {
                list.push({ collapsed: false })
              }
            })
            if (this.selected_filters.length > 0) {
              this.groups = this.$utils.clone(this.groups.filter((group) => this.selected_filters.includes(group[0].metric_group)))
              this.metrics_group = this.$utils.clone(this.selected_filters)
            }
          } else {
            this.checklists.map((x) => x.push({ collapsed: false }))
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.initChecklist()
          }, 500)
        })
    },
    deleteChecklist(showIsDone) {
      dataService.getForeCastChecklist({ page_size: 100, type: this.component_record.type }).then((result) => {
        let group = result.data.results.find((x) => x.name == this.checklist_group_selected)
        dataService.updateForeCastChecklist(group.id, { included_metrics: [] }).then(() => {
          this.show_delete_confirmation_modal = false
          this.initChecklist()
          showIsDone()
        })
      })
    }
  }
}
</script>
